<main class="marketplace-page py-5">
  <div class="container marketplace-container">
    <div class="row justify-content-center">
      <div class="col-md-9 col-lg-7">
        <section class="marketplace-card card border-0 shadow-sm">
          <div class="card-body text-center p-4 p-md-5">
            <span class="marketplace-result-icon d-inline-flex align-items-center justify-content-center mb-4">
              <i class="fas fa-check"></i>
            </span>
            <p class="marketplace-eyebrow text-uppercase fw-bold mb-2">Microsoft Marketplace</p>
            <h1 class="h2 fw-bold mb-3">Setup request received</h1>
            <p class="text-muted mb-4">
              Your environment will be prepared within 24-48 hours.
            </p>

            <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
              <button type="button" class="btn marketplace-primary-btn px-4" @click="go_to_login">
                Go to login
              </button>
              <button
                v-if="has_token"
                type="button"
                class="btn btn-outline-secondary px-4"
                @click="go_to_dashboard"
              >
                Go to dashboard
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>
